import styled, { css } from 'styled-components'

import { down } from 'styled-breakpoints'

export const FileDetailsStyles = {
  Content: styled.div`
    flex-direction: column;
  `,
}

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  padding: 25px;
  overflow: auto;
`

export const Container = styled.div<{ open: boolean }>`
  position: absolute;
  height: 80vh;
  border-radius: 30px 0px 0px 30px;
  background: ${({ theme }) => theme.colors.secondary};
  box-shadow: -6px 4px 32px 0px rgba(0, 0, 0, 0.25);
  width: 425px;
  flex-direction: column;
  backdrop-filter: blur(30px) saturate(2);
  -webkit-backdrop-filter: blur(30px) saturate(2);
  transition: 1s cubic-bezier(0.36, -0.01, 0, 0.77);
  overflow: hidden;
  top: 50px;
  display: flex;
  z-index: 100;
  flex-direction: column;
  gap: 10px;

  ${down('md')} {
    width: 100%;
    top: 0px;
    height: 100%;
    border-radius: 0px;
  }
  ${({ open }) =>
    open
      ? css`
          right: -0px;
        `
      : css`
          right: -100%;
        `}
`
